import { Formik, FormikProps, FormikValues } from 'formik';
import { HTMLAttributes } from 'react';

/**
 * Props received by the HOC rendering function
 */
interface SubformProps {
	field: {
		value: FormikValues;
		name: string;
	};
	form: FormikProps<unknown>;
	fieldProps: HTMLAttributes<unknown>;
}

/**
 * High Order Component to render a formik sub-form as a Field of the main form
 * @param SubForm
 * @param validationSchema
 */
export default function withSubForm(SubForm: React.ElementType, validationSchema: unknown) {
	return ({ field, form, ...fieldProps }: SubformProps) => {
		return (
			<Formik
				initialValues={field.value}
				validationSchema={validationSchema}
				onSubmit={() => {
					console.log('This will not trigger.');
				}}
				children={(props) => (
					<SubForm
						name={field.name}
						subFormProps={props}
						parentFormProps={form}
						fieldProps={fieldProps}
					/>
				)}
			/>
		);
	};
}
